"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderTitleViewWrap = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    wrapBorder: {
        display: "flex",
        justifyContent: "space-between",
        padding: 20,
        borderStyle: "solid",
        borderWidth: 1,
        borderRadius: 5,
        borderColor: theme ? theme.app.Setting.color9 : "",
        backgroundColor: theme ? theme.app.Setting.color8 : "",
    },
    left: {
        display: "flex",
        flexDirection: "column",
    },
    desc: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: 16,
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 4,
        color: theme ? theme.app.Setting.color10 : "",
    },
    text: {
        width: "100%",
        fontSize: 14,
        fontWeight: 400,
        color: theme ? theme.app.Setting.color2 : "",
    },
    right: {},
    pic: {},
}); });
function BorderTitleViewWrap(props) {
    var desc = props.desc, text = props.text, url = props.url;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.wrapBorder },
        React.createElement("div", { className: classes.left },
            desc !== undefined && React.createElement("div", { className: classes.desc }, desc),
            React.createElement("div", { className: classes.text }, text)),
        React.createElement("div", { className: classes.right }, url !== undefined && React.createElement("img", { className: classes.pic, src: url }))));
}
exports.BorderTitleViewWrap = BorderTitleViewWrap;
//# sourceMappingURL=BorderTitleViewWrap.js.map